import React, { Component } from 'react';
import axios from 'axios';
import CurrencyFormat from 'react-currency-format';
import { CompanyCombo } from './CompanyCombo';
import { NavLink, Container, Col, Row, Table, Form, FormGroup, FormText, Label } from 'reactstrap';
import { SpinButton, TextField, ComboBox, ResponsiveMode, MessageBar, MessageBarType, ActionButton } from '@fluentui/react';
import { Modal } from '@fluentui/react'
import { CalculationInfo } from './CalculationInfo';
import { QuoteHistoryList } from './QuoteHistoryList';
import { QuoteView } from './QuoteView';
const currencyFormatParams = {
    displayType: 'text',
    decimalScale: 2,
    fixedDecimalScale: true,
    thousandSeparator: true,
    prefix: '$'
};

const spinButtonStyles = {
    root: {
        minWidth: '130px'
    },
    spinButtonWrapper: {
        maxWidth: '66px',
    },
    labelWrapper: {
        minWidth: '130px'
    },
    input: {
        minWidth: '0px',
        maxWidth: '66px'
    }
};
export class EstimateEditor extends Component {
    static displayName = EstimateEditor.name;

    constructor(props) {
        super(props);
        var rootUrl = window.location.protocol + '//' + window.location.host + '/';

        var tmpSms = 0;

        this.state = { currentCount: 0, rootUrl: rootUrl, isAuthorized: false, headers: props.headers, editedEstimate: props.estimate, blockTimeOverridden: false, onboardingUnitPriceOverridden: false, quoteHistory: [], isQuoteOpen: false, viewedQuote: null };



        this.refresh_estimate = this.refresh_estimate.bind(this);
        this.reset_configs = this.reset_configs.bind(this);
        this.render_estimate = this.render_estimate.bind(this);
        this.onCompanyNameChange = this.onCompanyNameChange.bind(this);
        this.onRevenueChange = this.onRevenueChange.bind(this);
        this.onSmsTypeChange = this.onSmsTypeChange.bind(this);
        this.onRevenueChangeFluent = this.onRevenueChangeFluent.bind(this);
        this.onIndustryChange = this.onIndustryChange.bind(this);
        this.onFirstNameChange = this.onFirstNameChange.bind(this);
        this.onLastNameChange = this.onLastNameChange.bind(this);
        this.onPhoneChange = this.onPhoneChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onNtsaChange = this.onNtsaChange.bind(this);
        this.onLocationsChange = this.onLocationsChange.bind(this);
        this.onDomainsChange = this.onDomainsChange.bind(this);
        this.onUsersChange = this.onUsersChange.bind(this);
        this.onWorkstationsChange = this.onWorkstationsChange.bind(this);
        this.onServersChange = this.onServersChange.bind(this);
        this.onEsxHostsChange = this.onEsxHostsChange.bind(this);
        this.onFirewallsChange = this.onFirewallsChange.bind(this);
        this.onSwitchesRoutersChange = this.onSwitchesRoutersChange.bind(this);
        this.onWirelessControllersChange = this.onWirelessControllersChange.bind(this);
        this.onVirtualWirelessControllersChange = this.onVirtualWirelessControllersChange.bind(this);
        this.onAccessPointChange = this.onAccessPointChange.bind(this);
        this.onIpCameraChange = this.onIpCameraChange.bind(this);
        this.onIpPhoneChange = this.onIpPhoneChange.bind(this);
        this.onUpsChange = this.onUpsChange.bind(this);
        this.onBackupApplianceChange = this.onBackupApplianceChange.bind(this);
        this.onPrintersChange = this.onPrintersChange.bind(this);
        this.onBlockTimeQuantityChange = this.onBlockTimeQuantityChange.bind(this);
        this.onOtherSnmpDevicesChange = this.onOtherSnmpDevicesChange.bind(this);
        this.onOtherIcmpDevicesChange = this.onOtherIcmpDevicesChange.bind(this);
        this.onSanChange = this.onSanChange.bind(this);
        this.refresh_estimate = this.debounce_event(this.refresh_estimate, 500, false);
        this.resetBtuQuantity = this.resetBtuQuantity.bind(this);
        this.onCompanySelectionChange = this.onCompanySelectionChange.bind(this);
        this.resetOnboardingUnitPrice = this.resetOnboardingUnitPrice.bind(this);
        this.onOnboardingUnitPriceChange = this.onOnboardingUnitPriceChange.bind(this);
        this.getHistory = this.getHistory.bind(this);
        this.onOpenQuoteHistory = this.onOpenQuoteHistory.bind(this);
        this.onCloseQuote = this.onCloseQuote.bind(this);

    }

    componentDidUpdate(prevProps) {
        if (prevProps.estimate != this.props.estimate || prevProps.headers != this.props.headers) {
            var btOverridden = false;
            var obOverridden = false;
            var tmpSms = 0;
            if (this.props.estimate) {
                btOverridden = this.props.estimate.blockTimeQuantityOverride >= 0;
                obOverridden = this.props.estimate.onboardingUnitPriceOverride >= 0;

            }
            this.setState({ headers: this.props.headers, editedEstimate: this.props.estimate, blockTimeOverridden: btOverridden, onboardingUnitPriceOverridden: obOverridden });
            this.getHistory();

        }
    }
    getHistory() {
        if (this.props.estimate) {
            axios.get(this.state.rootUrl + "SmsQuoteHistory?smsEstimateId=" + this.props.estimate.id, { headers: this.state.headers }).then(res => {
                if (res.data) {
                    this.setState({ quoteHistory: res.data });
                }
            });
        }
    }

    refresh_estimate() {
        if (this.state.editedEstimate) {
            axios.post(this.state.rootUrl + 'SmsEstimates/CalculateEstimate', this.state.editedEstimate, { headers: this.state.headers }).then(res => {
                var estimate = res.data;
                if (estimate) {
                    this.updateEstimate(this.state.editedEstimate, estimate);
                }
            });
        }
    }
    reset_configs(estimate) {
        if (this.state.editedEstimate) {
            axios.get(this.state.rootUrl + 'SmsEstimates/resetConfigs/' + this.state.editedEstimate.id, { headers: this.state.headers }).then(res => {
                var estimate = res.data;
                if (estimate) {
                    var nEst = this.state.editedEstimate;
                    nEst.costingConfigs = estimate.costingConfigs;
                    nEst.costingConfigsAreDifferent = estimate.costingConfigsAreDifferent
                    this.setState({ editedEstimate: nEst });
                    axios.post(this.state.rootUrl + 'SmsEstimates/CalculateEstimate', estimate, { headers: this.state.headers }).then(res => {
                        this.updateEstimate(nEst, nEst);
                    });
                }
                else {

                }
            });
        }
    }


    debounce_event(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }


    updateEstimate(original_estimate, new_estimate) {
        if (this.props.onEstimateUpdated) {
            this.props.onEstimateUpdated(original_estimate, new_estimate);
        }
    }

    onCompanyNameChange(event) {
        var estimate = this.state.editedEstimate;

        estimate.companyName = event.target.value;
        this.updateEstimate(estimate, estimate);

    }

    onCompanySelectionChange(_, itm) {
        var estimate = this.state.editedEstimate;
        estimate.cwCompanyId = itm.key;
        this.updateEstimate(estimate, estimate);
        axios.get(this.state.rootUrl + 'CwCompany/' + itm.key, { headers: this.state.headers }).then(res => {
            var comp = res.data;
            if (comp) {
                estimate.cwCompany = comp;
                this.setState({ editedEstimate: estimate });
            }
        });
    }

    onPhoneChange(event) {
        var estimate = this.state.editedEstimate;
        estimate.phoneNumber = event.target.value;
        this.updateEstimate(estimate, estimate);
    }

    onEmailChange(event) {
        var estimate = this.state.editedEstimate;
        estimate.email = event.target.value;
        this.updateEstimate(estimate, estimate);
    }

    onFirstNameChange(event) {
        var estimate = this.state.editedEstimate;
        estimate.firstName = event.target.value;
        this.updateEstimate(estimate, estimate);
    }

    onLastNameChange(event) {
        var estimate = this.state.editedEstimate;
        estimate.lastName = event.target.value;
        this.updateEstimate(estimate, estimate);
    }

    onRevenueChange(event) {
        var estimate = this.state.editedEstimate;
        estimate.revenueId = event.target.value;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onRevenueChangeFluent(evt, option) {
        var key = option.key;
        var estimate = this.state.editedEstimate;
        estimate.revenueId = key;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onSmsTypeChange(evt, option) {
        var key = option.key;
        var estimate = this.state.editedEstimate;
        estimate.smsTypeId = key;
        estimate.smsTypeName = option.text;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onIndustryChange(event, option) {
        var key = option.key;
        var estimate = this.state.editedEstimate;
        estimate.industryId = key;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onLocationsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.locations = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }
    onDomainsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.domains = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }
    onNtsaChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.ntsa = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onUsersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.users = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onWorkstationsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.workstations = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onServersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.servers = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onEsxHostsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.esxHosts = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onSanChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.san = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onFirewallsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.firewalls = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onSwitchesRoutersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.switchesRouters = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onWirelessControllersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.wirelessControllers = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }
    onVirtualWirelessControllersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.virtualWirelessControllers = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }
    onAccessPointChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.accessPoint = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onIpCameraChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.ipCamera = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onIpPhoneChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.ipPhone = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onUpsChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.ups = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);

    }

    onBackupApplianceChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.backupAppliance = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);

    }

    onPrintersChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.printers = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onOtherSnmpDevicesChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.otherSnmpDevices = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onOtherIcmpDevicesChange(event, newValue) {
        var estimate = this.state.editedEstimate;
        estimate.otherIcmpDevices = newValue;
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    onBlockTimeQuantityChange(event) {
        var estimate = this.state.editedEstimate;
        var overridden = false;
        if (event.target.value == estimate.blockTimeQuantity) {
            estimate.blockTimeQuantityOverride = -1;
        }
        else {
            estimate.blockTimeQuantityOverride = event.target.value;
            overridden = true;
        }
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
        this.setState({ blockTimeOverridden: overridden });
    }

    onOnboardingUnitPriceChange(event) {
        var estimate = this.state.editedEstimate;

        var overridden = false;
        if (event.target.value == estimate.onboardingUnitPrice) {
            estimate.onboardingUnitPriceOverride = -1;
        }
        else {
            estimate.onboardingUnitPriceOverride = event.target.value;
            overridden = true;
        }
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
        this.setState({ onboardingUnitPriceOverridden: overridden });
    }

    onOpenQuoteHistory(item) {
        if (item && item.id) {
            axios.get(this.state.rootUrl + "SmsQuoteHistory/" + item.id, { headers: this.state.headers }).then(res => {
                if (res.data) {
                    this.setState({ isQuoteOpen: true, viewedQuote: res.data });
                }
            });
        }
    }
    onCloseQuote() {
        this.setState({ isQuoteOpen: false, viewedQuote: null });
    }

    resetBtuQuantity() {
        var estimate = this.state.editedEstimate;
        estimate.blockTimeQuantityOverride = -1;
        this.setState({ blockTimeOverridden: false });
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);

    }

    resetOnboardingUnitPrice() {
        var estimate = this.state.editedEstimate;
        estimate.onboardingUnitPriceOverride = -1;
        this.setState({ onboardingUnitPriceOverridden: false });
        this.refresh_estimate(estimate, estimate);
        this.updateEstimate(estimate, estimate);
    }

    render() {
        const estimate = this.state.editedEstimate;

        let output;
        if (!estimate) {
            output = <p>Loading...</p>;
        } else {
            output = this.render_estimate(estimate)
        }
        return output;
    }

    render_money(value) {
        if (value === null) {
            return (<span>ICB</span>);
        } else {
            return (<CurrencyFormat value={value} {...currencyFormatParams} />);
        }
    }

    render_estimate(estimate) {
        const lookups = this.props.lookups;
        var revenues = [];
        var industries = [];
        var smsTypes = [];
        var revenueOptions = [{ key: null, text: 'Not Selected' }];
        var industryOptions = [{ key: null, text: 'Not Selected' }];
        var smsOptions = [{ key: null, text: 'Not Selected' }];
        var territory = "";
        if (estimate.cwCompany) {
            territory = estimate.cwCompany.territory;
        }
        if (lookups) {
            if (lookups.revenues) {
                revenues = lookups.revenues;
                revenueOptions = revenueOptions.concat(revenues.map((curr, ind) => {
                    return { key: curr.id, text: curr.rangeText };
                }));
            }
            if (lookups.industries) {
                industries = lookups.industries;
                industryOptions = industryOptions.concat(industries.map((curr, ind) => {
                    return { key: curr.id, text: curr.name };
                }));
            }
            if (lookups.smsTypes) {
                smsTypes = lookups.smsTypes;
                smsOptions = smsOptions.concat(smsTypes.map((curr, ind) => {
                    return { key: curr.id, text: curr.name };
                }));
            }
        }


        return (
            <Container fluid={true}>
                <Row>
                    <QuoteHistoryList items={this.state.quoteHistory} onOpen={this.onOpenQuoteHistory} />
                </Row>
                <Row>
                    Estimate Calculation Version: {estimate.formulaVersion} {(estimate.formulaVersion != estimate.currentFormulaVersion && estimate.id != 0) &&
                        <span>&nbsp;Current Version {estimate.currentFormulaVersion}</span>
                    }
                </Row>
                {(estimate.formulaVersion != estimate.currentFormulaVersion && estimate.id != 0) &&
                    <Row>
                        <MessageBar messageBarType={MessageBarType.severeWarning} >
                            This estimate with an older version of data and calculations.  Please verify that all counts and calculations are correct before saving, or refer to a historical copy.
                        </MessageBar>
                    </Row>
                }
                {
                    (estimate.costingConfigsAreDifferent) &&
                    <Row>
                        <MessageBar messageBarType={MessageBarType.info} >
                            {estimate.costingConfigsAreDifferent} The cost defintions for this estimate are different than the current defaults. <ActionButton onClick={this.reset_configs}>Reset to Default</ActionButton>
                        </MessageBar>
                    </Row>
                }
                <Row>
                    <Col md={6}>
                        <h4>Company Information</h4>
                        <Form>
                            <FormGroup>
                                {/*<TextField label="Company Name" value={estimate.companyName} placeholder="Enter Company Name" onChange={this.onCompanyNameChange} />*/}
                                {/*<Label for="companyName">Company Name</Label>*/}
                                <CompanyCombo selectedKey={estimate.cwCompanyId} onChange={this.onCompanySelectionChange} />
                                {/*<Input type="text" name="CompanyName" id="companyName" value={estimate.companyName} onChange={this.onCompanyNameChange} />*/}
                            </FormGroup>
                            <FormGroup>
                                <TextField label="Territory" value={territory} disabled />
                            </FormGroup>
                            <FormGroup>
                                <ComboBox label="Product" options={smsOptions} selectedKey={estimate.smsTypeId} onChange={this.onSmsTypeChange} />
                            </FormGroup>
                            <FormGroup>
                                <ComboBox label="Gross Annual revenue" options={revenueOptions} selectedKey={estimate.revenueId} onChange={this.onRevenueChangeFluent} />
                                {/*<Label for="revenueRange">Gross Annual Revenue</Label>*/}
                                {/*<Input type="select" name="RevenueRange" id="revenueRange" value={estimate.revenueId || ''} onChange={this.onRevenueChange}>*/}
                                {/*    <option value=''>Not Selected</option>*/}
                                {/*    {revenues.map((curr, ind) => <option key={ind} value={curr.id}>{curr.rangeText}</option>)}*/}
                                {/*</Input>*/}
                            </FormGroup>
                            <FormGroup>
                                <ComboBox label="Vertical" options={industryOptions} selectedKey={estimate.industryId} onChange={this.onIndustryChange} />
                                {/*<Label for="companyVertical">Vertical</Label>*/}
                                {/*<Input type="select" name="CompanyVertical" id="companyVertical" value={estimate.industryId || ''} onChange={this.onIndustryChange}>*/}
                                {/*    <option value=''>Not Selected</option>*/}
                                {/*    {industries.map((curr, ind) => <option key={ind} value={curr.id}>{curr.name}</option>)}*/}
                                {/*</Input>*/}
                            </FormGroup>
                            <FormGroup>
                                <FormText>Contact Information</FormText>
                            </FormGroup>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <TextField label="First Name" value={estimate.firstName} placeholder="First Name" onChange={this.onFirstNameChange} />
                                        {/*<Label for="firstName">First Name</Label>*/}
                                        {/*<Input type="text" name="FirstName" id="firstName" placeholder="First Name" value={estimate.firstName} onChange={this.onFirstNameChange} />*/}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <TextField label="Last Name" value={estimate.lastName} placeholder="Last Name" onChange={this.onLastNameChange} />
                                        {/*<Label for="lastName">Last Name</Label>*/}
                                        {/*<Input type="text" name="LastName" id="lastName" placeholder="Last Name" value={estimate.lastName} onChange={this.onLastNameChange} />*/}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <TextField label="Phone" value={estimate.phoneNumber} placeholder="Phone Number" onChange={this.onPhoneChange} />
                                        {/*<Label for="phone">Phone</Label>*/}
                                        {/*<Input type="text" name="Phone" id="phone" placeholder="Phone Number" value={estimate.phoneNumber} onChange={this.onPhoneChange} />*/}
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <TextField label="Email" type="email" value={estimate.email} placeholder="Email Address" onChange={this.onEmailChange} />
                                    {/*<Label for="email">Email</Label>*/}
                                    {/*<Input type="email" name="Email" id="email" placeholder="Email address" value={estimate.email} onChange={this.onEmailChange} />*/}
                                </Col>
                            </Row>
                            <FormGroup>
                                <FormText>Item Counts</FormText>
                            </FormGroup>
                            <Row form>

                                <Col md={3}>
                                    <SpinButton label="NTSA"
                                        value={estimate.ntsa}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onNtsaChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Users"
                                        value={estimate.users}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onUsersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Workstations"
                                        value={estimate.workstations}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onWorkstationsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="Servers"
                                        value={estimate.servers}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onServersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="ESX/VM Hosts"
                                        value={estimate.esxHosts}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onEsxHostsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="SAN"
                                        value={estimate.san}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onSanChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>

                            </Row>

                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="Firewalls"
                                        value={estimate.firewalls}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onFirewallsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Switches / Routers"
                                        value={estimate.switchesRouters}
                                        defaultValue="0"
                                        min={0} step={1} max={1000000}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onSwitchesRoutersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Phys Wireless Ctrlrs"
                                        value={estimate.wirelessControllers}
                                        defaultValue="0"
                                        min={0} step={1} max={1000000}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onWirelessControllersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="Virt Wireless Ctrlrs"
                                        value={estimate.virtualWirelessControllers}
                                        defaultValue="0"
                                        min={0} step={1} max={1000000}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onVirtualWirelessControllersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Access Points"
                                        value={estimate.accessPoint}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onAccessPointChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="IP Cameras"
                                        value={estimate.ipCamera}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onIpCameraChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="IP Phones"
                                        value={estimate.ipPhone}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onIpPhoneChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="UPS"
                                        value={estimate.ups}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onUpsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Backup Appliances"
                                        value={estimate.backupAppliance}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onBackupApplianceChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="Printers"
                                        value={estimate.printers}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onPrintersChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Other SNMP Devices"
                                        value={estimate.otherSnmpDevices}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onOtherSnmpDevicesChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Other ICMP Devices"
                                        value={estimate.otherIcmpDevices}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onOtherIcmpDevicesChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>

                            </Row>
                            <Row form>
                                <Col md={3}>
                                    <SpinButton label="Locations"
                                        value={estimate.locations}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onLocationsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                                <Col md={3}>
                                    <SpinButton label="Domains"
                                        value={estimate.domains}
                                        defaultValue="0"
                                        min={0} step={1}
                                        incrementButtonAriaLabel="Increase value by 1"
                                        decrementButtonAriaLabel="Decrease value by 1" onChange={this.onDomainsChange}
                                        styles={spinButtonStyles}
                                    />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col>
                        <h4>Estimate Results</h4>

                        <h5>Initial Fees</h5>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>Qty</th>
                                    <th>Unit $</th>
                                    <th className="resultExtWidth">Ext $</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Onboarding</td>
                                    <td>1</td>
                                    <td><TextField className={this.state.onboardingUnitPriceOverridden ? "overriddenField" : ""} value={estimate.onboardingUnitPriceOverride < 0 ? estimate.onboardingUnitPrice : estimate.onboardingUnitPriceOverride} onChange={this.onOnboardingUnitPriceChange} placeholder="0" tooltip={this.state.onboardingUnitPriceOverridden ? "Overridden from " + estimate.onboardingUnitPrice : ""} /></td>
                                    {/*<td><CurrencyFormat value={estimate.onboardingUnitPrice} {...currencyFormatParams} /></td>*/}
                                    <td><CurrencyFormat value={estimate.onboardingExtPrice} {...currencyFormatParams} /></td>
                                </tr>
                                {this.state.onboardingUnitPriceOverridden &&
                                    <tr className="d-print-none">
                                        <td>&nbsp;</td>
                                        <td colSpan="3">
                                            Onboarding Unit Price has been overridden from {estimate.onboardingUnitPrice}.  <NavLink href="#" onClick={this.resetOnboardingUnitPrice} >Reset To Calculated Value</NavLink>
                                        </td>
                                    </tr>
                                }
                                <tr>
                                    <td>Initial Assessment</td>
                                    <td>1</td>
                                    <td><CurrencyFormat value={estimate.initialAssessmentUnitPrice} {...currencyFormatParams} /></td>
                                    <td><CurrencyFormat value={estimate.initialAssessmentExtPrice} {...currencyFormatParams} /></td>
                                </tr>
                                <tr>
                                    <td>Initial Policy Mgmt.</td>
                                    <td>1</td>
                                    <td><CurrencyFormat value={estimate.initialPolicyManagementUnitPrice} {...currencyFormatParams} /></td>
                                    <td><CurrencyFormat value={estimate.initialPolicyManagementExtPrice} {...currencyFormatParams} /></td>
                                </tr>


                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th><CurrencyFormat value={estimate.totalInitialFees} {...currencyFormatParams} /> NRC</th>
                                </tr>
                            </tfoot>
                        </Table>

                        <h5>Annual Cyber Insurance Fee</h5>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th className="resultExtWidth">Ext $</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Cyber Policy</td>
                                    <td>{this.render_money(estimate.cyberInsuranceFee)}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>{this.render_money(estimate.cyberInsuranceFee)} Annual</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <h5>SMS Monthly Fees</h5>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>Qty</th>
                                    <th>Unit $</th>
                                    <th className="resultExtWidth">Ext $</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Endpoints</td>
                                    <td>{estimate.endPointQty}</td>
                                    <td>{this.render_money(estimate.endpointUnitPrice)}</td>
                                    <td>{this.render_money(estimate.endpointExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>Devices</td>
                                    <td>{estimate.deviceQty}</td>
                                    <td>{this.render_money(estimate.deviceUnitPrice)}</td>
                                    <td>{this.render_money(estimate.deviceExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>Users</td>
                                    <td>{estimate.userQty}</td>

                                    <td>{this.render_money(estimate.userUnitPrice)}</td>
                                    <td>{this.render_money(estimate.userExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>NTSA Locations</td>
                                    <td>{estimate.locationQty}</td>
                                    <td>{this.render_money(estimate.locationUnitPrice)}</td>
                                    <td>{this.render_money(estimate.locationExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>Mon. Devices</td>
                                    <td>{estimate.mDeviceQty}</td>
                                    <td>{this.render_money(estimate.mDeviceUnitPrice)}</td>
                                    <td>{this.render_money(estimate.mDeviceExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>Companies</td>
                                    <td>1</td>
                                    <td>{this.render_money(estimate.companyUnitPrice)}</td>
                                    <td>{this.render_money(estimate.companyExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>SOC Devices</td>
                                    <td>{estimate.socDeviceQty}</td>
                                    <td>{this.render_money(estimate.socDeviceUnitPrice)}</td>
                                    <td>{this.render_money(estimate.socDeviceExtPrice)}</td>
                                </tr>
                                <tr>
                                    <td>Domains</td>
                                    <td>{estimate.domainsQty}</td>
                                    <td>{this.render_money(estimate.domainsUnitPrice)}</td>
                                    <td>{this.render_money(estimate.domainsExtPrice)}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>{this.render_money(estimate.totalSmsMonthlyFees)} MRC</th>
                                </tr>
                            </tfoot>
                        </Table>
                        <h5>Block Time Estimate</h5>
                        <Table striped size="sm">
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>Qty</th>
                                    <th>Unit $</th>
                                    <th className="resultExtWidth">Ext $</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Monthly BTU</td>
                                    <td>
                                        <TextField className={this.state.blockTimeOverridden ? "overriddenField" : ""} value={estimate.blockTimeQuantityOverride < 0 ? estimate.blockTimeQuantity : estimate.blockTimeQuantityOverride} onChange={this.onBlockTimeQuantityChange} placeholder="0" tooltip={this.state.blockTimeOverridden ? "Overridden from " + estimate.blockTimeQuantity : ""} />
                                        {/*<Input className={this.state.blockTimeOverridden ? "overriddenField" : ""} type="number" step="1" id="blockTimeQty" placeholder="0" value={estimate.blockTimeQuantityOverride == 0 ? estimate.blockTimeQuantity : estimate.blockTimeQuantityOverride} onChange={this.onBlockTimeQuantityChange} tooltip={this.state.blockTimeOverridden ? "Overridden from " + estimate.blockTimeQuantity : ""} />*/}
                                    </td>
                                    <td>{this.render_money(estimate.blockTimeUnitPrice)}</td>
                                    <td>{this.render_money(estimate.blockTimeExtPrice)}</td>
                                </tr>
                                {this.state.blockTimeOverridden &&
                                    <tr className="d-print-none">
                                        <td>&nbsp;</td>
                                        <td colSpan="3">
                                            Monthly BTU Quantity has been overridden from {estimate.blockTimeQuantity}.  <NavLink href="#" onClick={this.resetBtuQuantity} >Reset To Calculated Value</NavLink>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>{this.render_money(estimate.blockTimeExtPrice)} MRC</th>
                                </tr>
                            </tfoot>
                        </Table>
                    </Col>
                </Row>
                <CalculationInfo items={estimate.calculationInfo} />
                <Modal isOpen={this.state.isQuoteOpen} onDismiss={this.onCloseQuote} responsiveMode={ResponsiveMode.large}>
                    <QuoteView quote={this.state.viewedQuote} />
                </Modal>
            </Container>
        );
    }

}
